var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifiche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1469_8211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.58065C17.9855 8.58065 19.595 6.9711 19.595 4.98563C19.595 3.00017 17.9855 1.39062 16 1.39062C14.0145 1.39062 12.405 3.00017 12.405 4.98563C12.405 6.9711 14.0145 8.58065 16 8.58065Z",
    fill: "#F8AD3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5732 22.4609L16 25.2572L4.42674 22.4609C5.21309 20.9274 6.01573 19.1084 6.01573 14.7675C6.01573 9.25329 10.4859 4.7832 16 4.7832C21.5141 4.7832 25.9842 9.25335 25.9842 14.7675C25.9842 19.1085 26.7869 20.9274 27.5732 22.4609Z",
    fill: "#F8EA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 31.9988C18.5529 31.9988 20.6224 29.9292 20.6224 27.3763C20.6224 24.8234 18.5529 22.7539 16 22.7539C13.4471 22.7539 11.3776 24.8234 11.3776 27.3763C11.3776 29.9292 13.4471 31.9988 16 31.9988Z",
    fill: "#F8EA69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8148 25.4946C28.5352 24.2428 28.0572 23.4061 27.5732 22.4609H4.42675C3.94289 23.4061 3.46488 24.2428 3.18519 25.4946C2.89217 26.8062 3.88359 28.0535 5.22759 28.0535H26.7725C28.1164 28.0535 29.1078 26.8062 28.8148 25.4946Z",
    fill: "#F8AD3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1469_8211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifiche);
export default __webpack_public_path__ + "static/media/notifiche.39098b7678874eff956515ac55ea8ef5.svg";
export { ForwardRef as ReactComponent };